// @flow

import React, { PureComponent } from "react";
import { get } from "lodash";
import type { Payoffs } from "@tvg/types/Race";
import { formatCurrency } from "@tvg/formatter";
import {
  PayoffRow,
  PayOffValue,
  Selections,
  PayoffInfo,
  PayoffInfoWrapper
} from "./styled-components";

type Props = {
  payoff: Payoffs
};

export default class RaceResultsPayoff extends PureComponent<Props> {
  static defaultProps = {
    payoff: {
      wagerAmount: 0,
      wagerType: {
        code: "",
        name: ""
      },
      selections: [
        {
          payoutAmount: 0,
          selection: ""
        }
      ]
    }
  };

  render() {
    const selections = get(this.props.payoff, "selections[0].selection");
    return (
      <PayoffRow data-qa-label="racePayoffs-row">
        <PayoffInfoWrapper>
          <PayoffInfo data-qa-label="racePayoffs-row-betAmount">{`${formatCurrency(
            get(this.props.payoff, "wagerAmount")
          )} ${get(this.props.payoff, "wagerType.name")}`}</PayoffInfo>
          <PayOffValue data-qa-label="racePayoffs-row-payoutAmount">
            {selections !== "Refund"
              ? formatCurrency(
                  get(this.props.payoff, "selections[0].payoutAmount")
                )
              : "Refund"}
          </PayOffValue>
        </PayoffInfoWrapper>
        {selections !== "Refund" && (
          <Selections data-qa-label="racePayoffs-row-selections">
            {selections}
          </Selections>
        )}
      </PayoffRow>
    );
  }
}
